import { render, staticRenderFns } from "./FormTitle.vue?vue&type=template&id=5c964512&scoped=true&"
import script from "./FormTitle.vue?vue&type=script&lang=ts&"
export * from "./FormTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c964512",
  null
  
)

export default component.exports